export interface SocialMediaScores {
  strategyPresence: number;
  contentEngagement: number;
  advertisingROI: number;
}

export interface SocialMediaResult {
  questionId: number;
  selectedOption: number;
  scores: SocialMediaScores;
}

export interface Question {
  id: number;
  question: string;
  options: {
    text: string;
    scores: SocialMediaScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    question: "How active and strategic is your social media presence?",
    options: [
      {
        text: "Very strategic - consistent posting schedule across multiple platforms with clear goals",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Moderately active - we post regularly but without a formal strategy",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 1 }
      },
      {
        text: "Sporadic - we post occasionally when we have time or something to share",
        scores: { strategyPresence: 3, contentEngagement: 2, advertisingROI: 2 }
      },
      {
        text: "Minimal or none - we barely use social media or have inactive accounts",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 2,
    question: "Which social media platforms are you actively using for your Saskatchewan business?",
    options: [
      {
        text: "Strategic mix - active on 3+ platforms where our target audience is",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Few platforms - mainly Facebook and maybe Instagram or LinkedIn",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 1 }
      },
      {
        text: "Single platform - we only use one social media channel",
        scores: { strategyPresence: 3, contentEngagement: 2, advertisingROI: 2 }
      },
      {
        text: "No presence - we don't have active social media accounts",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 3,
    question: "What type of content are you creating and sharing on social media?",
    options: [
      {
        text: "Diverse content mix - original posts, videos, stories, user-generated content, live streams",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Basic variety - mix of photos, text posts, and occasional videos",
        scores: { strategyPresence: 1, contentEngagement: 2, advertisingROI: 1 }
      },
      {
        text: "Limited - mostly text posts or shared content from others",
        scores: { strategyPresence: 2, contentEngagement: 3, advertisingROI: 2 }
      },
      {
        text: "Minimal - we rarely create original content",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 4,
    question: "How engaged is your social media audience with your content?",
    options: [
      {
        text: "Highly engaged - consistent likes, comments, shares, and meaningful conversations",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Moderate engagement - some likes and occasional comments",
        scores: { strategyPresence: 1, contentEngagement: 2, advertisingROI: 2 }
      },
      {
        text: "Low engagement - minimal interaction with our posts",
        scores: { strategyPresence: 2, contentEngagement: 3, advertisingROI: 2 }
      },
      {
        text: "No engagement - our posts get little to no response",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 5,
    question: "Do you actively engage with your followers and respond to comments/messages?",
    options: [
      {
        text: "Very responsive - we reply quickly and foster community conversations",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Sometimes - we respond when we remember to check",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 1 }
      },
      {
        text: "Rarely - we don't have time to engage with comments or messages",
        scores: { strategyPresence: 2, contentEngagement: 3, advertisingROI: 2 }
      },
      {
        text: "Never - we post but don't monitor or respond",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 6,
    question: "Are you using paid social media advertising to reach your Saskatchewan audience?",
    options: [
      {
        text: "Strategic campaigns - targeted ads with clear objectives and good ROI",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Occasional boosting - we boost posts sometimes but no formal ad strategy",
        scores: { strategyPresence: 1, contentEngagement: 2, advertisingROI: 2 }
      },
      {
        text: "Tried once or twice - experimented but didn't see results",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 3 }
      },
      {
        text: "No paid advertising - we only use organic social media",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 3 }
      }
    ]
  },
  {
    id: 7,
    question: "How do you measure and optimize your social media performance?",
    options: [
      {
        text: "Data-driven - track metrics, analyze performance, test and optimize regularly",
        scores: { strategyPresence: 1, contentEngagement: 1, advertisingROI: 1 }
      },
      {
        text: "Basic tracking - check insights occasionally but don't act on them",
        scores: { strategyPresence: 2, contentEngagement: 2, advertisingROI: 2 }
      },
      {
        text: "Vanity metrics - only look at follower count and likes",
        scores: { strategyPresence: 2, contentEngagement: 3, advertisingROI: 3 }
      },
      {
        text: "No tracking - we don't measure social media results",
        scores: { strategyPresence: 3, contentEngagement: 3, advertisingROI: 3 }
      }
    ]
  }
];
